export default __webpack_public_path__ + "static/media/787.82cc9268.png";